if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.quantity = this.querySelector('quantity-input');

        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
          ) {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      get input() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.input?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.input?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.input?.blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      get sectionId() {
        if (!this._sectionId) {
          this._sectionId = this.closest('.collection-quick-add-bulk').dataset.id;
        }

        return this._sectionId;
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          fetch(`${this.getSectionsUrl()}?section_id=${this.sectionId}`)
            .then((response) => response.text())
            .then((responseText) => {
              const html = new DOMParser().parseFromString(responseText, 'text/html');
              const sourceQty = html.querySelector(`#quick-add-bulk-${this.dataset.index}-${this.sectionId}`);
              if (sourceQty) {
                this.innerHTML = sourceQty.innerHTML;
              }
              resolve();
            })
            .catch((e) => {
              console.error(e);
              reject(e);
            });
        });
      }

      getSectionsUrl() {
        const pageParams = new URLSearchParams(window.location.search);
        const pageNumber = decodeURIComponent(pageParams.get('page') || '');

        return `${window.location.pathname}${pageNumber ? `?page=${pageNumber}` : ''}`;
      }

       updateMultipleQty(items) {
        const ids = Object.keys(items);
        const previousQuantities = {};

        const findCard = (id) =>
          document.getElementById(
            `quick-add-bulk-${id}-${this.sectionId}`
          );

        ids.forEach((id) => {
          const input = findCard(id)?.querySelector('.quantity__input');
          previousQuantities[id] = Number(
            input?.dataset.cartQuantity || 0
          );
        });

        const showMessage = (id, text, isError = false) => {
          const card = findCard(id);
          if (!card) return;

          let message = card.querySelector('.gs-cart-feedback');

          if (!message) {
            message = document.createElement('p');
            message.className = 'gs-cart-feedback';
            message.setAttribute('role', 'status');
            message.setAttribute('aria-live', 'polite');
            message.style.cssText =
              'margin:6px 0 0;text-align:center;' +
              'font-size:12px;line-height:1.4;min-height:17px;';
            card.appendChild(message);
          }

          clearTimeout(message.gsHideTimer);
          message.style.color = isError ? '#b42318' : '#1a4335';
          message.textContent = text;

          if (!isError) {
            message.gsHideTimer = setTimeout(() => {
              message.textContent = '';
            }, 3500);
          }
        };

        this.selectProgressBar()?.classList.remove('hidden');

        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map(
            (section) => section.section
          ),
          sections_url: this.getSectionsUrl(),
        });

        fetch(routes.cart_update_url, {
          ...fetchConfig(),
          body,
        })
          .then(async (response) => {
            const state = await response.json();

            if (
              !response.ok ||
              state.errors ||
              state.status ||
              !Array.isArray(state.items)
            ) {
              throw new Error(
                state.description || 'No se pudo actualizar la cesta.'
              );
            }

            return state;
          })
          .then((parsedState) => {
            this.renderSections(parsedState, ids);

            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'quick-add',
              cartData: parsedState,
            });

            ids.forEach((id) => {
              const actualQuantity = parsedState.items
                .filter((item) => String(item.variant_id || item.id) === id)
                .reduce((total, item) => total + item.quantity, 0);

              const requestedQuantity = Number(items[id]);
              const previousQuantity = previousQuantities[id];

              if (actualQuantity !== requestedQuantity) {
                showMessage(id, 'Revisa la cantidad disponible.', true);
                return;
              }

              if (actualQuantity === previousQuantity) return;

              const text =
                actualQuantity === 0
                  ? 'Retirado de la cesta'
                  : actualQuantity > previousQuantity
                    ? 'Añadido a la cesta'
                    : 'Cantidad actualizada';

              showMessage(id, text);
            });
          })
          .catch((error) => {
            console.error(error);

            ids.forEach((id) => {
              showMessage(
                id,
                'No se pudo confirmar el cambio. Revisa la cesta.',
                true
              );
            });
          })
          .finally(() => {
            this.selectProgressBar()?.classList.add('hidden');
            this.setRequestStarted(false);
          });
      }


      getSectionsToRender() {
        return [
          {
            id: `quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
            section: this.sectionId,
            selector: `#quick-add-bulk-${this.dataset.index}-${this.sectionId}`,
          },
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '.drawer__inner',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (section.section === 'cart-drawer') {
           sectionElement?.closest('cart-drawer')?.classList.toggle('is-empty', parsedState.items.length === 0);
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
